declare var InovxLoader: any;

var CommonMessages = {
    Validation: {

    }
}

Object.defineProperty(CommonMessages.Validation, "Required", { get: () => InovxLoader.t("common:message.requiredInput") });
Object.defineProperty(CommonMessages.Validation, "AnyNumber", { get: () => InovxLoader.t("common:message.inputNeedsToBeNumber") });
Object.defineProperty(CommonMessages.Validation, "PositiveNumber", { get: () => InovxLoader.t("common:message.inputNeedsToBePositiveNumber") });
Object.defineProperty(CommonMessages.Validation, "PositiveInteger", { get: () => InovxLoader.t("common:message.inputNeedsToBePositiveInteger") });

export default CommonMessages as ICommonMessages;